module.exports = __webpack_public_path__ + "static/img/img_2.4160015.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_atp/img_2.png
// module id = y0g1
// module chunks = 0